import React from 'react';
import classNames from "classnames";
import AnimateButtonHelper from 'helpers/utilities/animate-button';

export default class Button extends React.Component {
  constructor(props){
    super();

    this.setUpHandlers();
  }

  /**
   * React Lifecycle Hook
   * Invoked once, immediately after the initial rendering occurs.
   *
   * @method  componentDidMount
   */
  componentDidMount() {
    this.initAnimationHelper();
  }

  initAnimationHelper() {
    if (!this.props.animateOnClick) return;

    const animateProps = {
      'button': this.button,
      'buttonFill': this.buttonFill,
      'onComplete': this.handleOnClick.bind(this),
    };

    this.animateButtonHelper = new AnimateButtonHelper(animateProps);
  }

  /**
   * React Lifecycle Hook
   * Invoked immediately before a component is unmounted and destroyed.
   * Perform any necessary cleanup in this method
   *
   * @method  componentWillUnmount
   */
  componentWillUnmount() {
    if (!this.props.animateOnClick) return;

    this.animateButtonHelper.disable();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  /**
   * If an action and/or onclick action exists, the click
   * will fire off the relative actions.
   *
   * @method  handleOnClick
   */
  handleOnClick(event) {
    if (event) event.preventDefault();

    if (this.props.action) this.props.action();
    if (this.props.onClick) this.props.onClick();
  }

  _renderAnimating() {
    return (
      <span className="btn-container">
        {this._renderStaticButton()}
        <span className="btn-fill" ref={el => { this.buttonFill = el; }}></span>
      </span>
    );
  }

  _renderStaticButton() {
    const { className, children, theme, active, color, disabled, secondary, type="button" } = this.props;
    const btnClasses = classNames(
      'btn',
      {
        'btn_active': active,
        [`btn_${theme}`]: theme,
        [`btn_secondary`]: secondary,
        [`mix-btn_color${color}`]: color
      },
      className
    );

    return (
      <button
        className={btnClasses}
        disabled={disabled}
        ref={el => { this.button = el; }}
        onClick={this.handleOnClick}
        type={type}
      >
        {children}
      </button>
    );
  }

  render() {
    if (this.props.animateOnClick) {
      return this._renderAnimating();
    }
    else {
      return this._renderStaticButton();
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/components/button/button.jsx